var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { IsBoolean, IsOptional, IsString, IsUUID } from 'class-validator';
export class OnboardUserPatientByTherapistDto {
    salutation;
    firstName;
    lastName;
    birthday;
    telephone;
    krankenkasse;
    agreedNewsletter;
    therapistId;
}
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], OnboardUserPatientByTherapistDto.prototype, "salutation", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], OnboardUserPatientByTherapistDto.prototype, "firstName", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], OnboardUserPatientByTherapistDto.prototype, "lastName", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], OnboardUserPatientByTherapistDto.prototype, "birthday", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], OnboardUserPatientByTherapistDto.prototype, "telephone", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], OnboardUserPatientByTherapistDto.prototype, "krankenkasse", void 0);
__decorate([
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], OnboardUserPatientByTherapistDto.prototype, "agreedNewsletter", void 0);
__decorate([
    IsUUID(),
    IsOptional(),
    __metadata("design:type", String)
], OnboardUserPatientByTherapistDto.prototype, "therapistId", void 0);
//# sourceMappingURL=onboard-user-patient-by-therapist.dto.js.map